import { render } from "./InvoicesPrint.vue?vue&type=template&id=153b1002&scoped=true&ts=true"
import script from "./InvoicesPrint.vue?vue&type=script&lang=ts"
export * from "./InvoicesPrint.vue?vue&type=script&lang=ts"

import "./InvoicesPrint.vue?vue&type=style&index=0&id=153b1002&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153b1002"]])

export default __exports__